import { NavTabs } from '~/components/navigation/NavTabs';
import {
  uploadPaleoMapUpdatePicturesRoute,
  uploadPaleoMapUpdateRoute,
} from '~/paths';

export function UploadPaleoMapNavigation({
  id,
  disabled,
}: {
  id: number;
  disabled?: boolean;
}) {
  return (
    <NavTabs>
      <NavTabs.Tab to={uploadPaleoMapUpdateRoute(id)} disabled={disabled} end>
        Details
      </NavTabs.Tab>
      <NavTabs.Tab
        to={uploadPaleoMapUpdatePicturesRoute(id)}
        disabled={disabled}
      >
        Pictures
      </NavTabs.Tab>
    </NavTabs>
  );
}
